// extracted by mini-css-extract-plugin
export var chevron = "_2p-2";
export var chevronCollapsed = "_2p-3";
export var collapsibleHeader = "_2p-1";
export var container = "_2p-0";